import React, { useEffect, useRef } from 'react'
import { useGetImagebyId } from '../../hooks/useNews'

interface NewsImageProps {
  articleId: number
  className?: string
}

export const NewsImage: React.FC<NewsImageProps> = ({
  articleId,
  className
}) => {
  const { data: image, isError, isPending } = useGetImagebyId(articleId)
  if (isError || isPending || !image) {
    return <></>
  }
  return <NewsImageBlob key={articleId} image={image} className={className} />
}

const NewsImageBlob = ({
  image,
  className
}: {
  image: Blob
  className?: string
}) => {
  const imageRef = useRef<HTMLImageElement>(null)
  useEffect(() => {
    const url = URL.createObjectURL(image)
    const element = imageRef.current
    if (element) element.src = url
    return () => {
      if (element) element.removeAttribute('src')
      URL.revokeObjectURL(url)
    }
  }, [image])
  return <img ref={imageRef} className={className} alt='' />
}
